import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { Button } from '@whitbread-eos/atoms';
import { formatAssetsUrl, formatDataTestId } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MAX_NUMBER_OF_CARDS = 2;
export default function TravelGuides(_ref) {
  var data = _ref.data,
    baseDataTestId = _ref.baseDataTestId;
  var sortedCards = data === null || data === void 0 ? void 0 : data.sort((a, b) => {
    var _a$order, _b$order;
    return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : 0) - ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : 0);
  });
  return _jsx(Flex, _objectSpread(_objectSpread({
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper')
  }, travelGuidesContainerStyles), {}, {
    w: data.length < MAX_NUMBER_OF_CARDS ? {
      mobile: 'full',
      xl: 'calc(50% - 12px)'
    } : undefined,
    children: sortedCards === null || sortedCards === void 0 ? void 0 : sortedCards.map(item => {
      var _item$picture;
      return _jsxs(Flex, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, 'Card')
      }, cardStyles), {}, {
        w: data.length < MAX_NUMBER_OF_CARDS ? {
          mobile: 'full',
          lg: 'calc(50% - 12px)',
          xl: 'full'
        } : {
          mobile: 'full'
        },
        children: [_jsxs(Flex, _objectSpread(_objectSpread({
          justifyContent: "space-between",
          flexDirection: "column"
        }, cardInnerStyles), {}, {
          children: [_jsxs(Box, {
            children: [_jsx(Heading, _objectSpread(_objectSpread({
              as: "h4",
              "data-testid": formatDataTestId(baseDataTestId, 'Title')
            }, titleStyles), {}, {
              children: item.title
            })), _jsx(Text, _objectSpread(_objectSpread({}, descriptionStyles), {}, {
              "data-testid": formatDataTestId(baseDataTestId, 'Description'),
              children: item.description
            }))]
          }), _jsx(Button, _objectSpread(_objectSpread({
            variant: "primary",
            size: "sm",
            formTarget: item.linkTarget,
            "data-testid": formatDataTestId(baseDataTestId, 'Button'),
            onClick: () => {
              var _item$linkUrl;
              window.location.href = (_item$linkUrl = item.linkUrl) !== null && _item$linkUrl !== void 0 ? _item$linkUrl : '';
            }
          }, buttonStyles), {}, {
            children: item.linkText
          }))]
        })), _jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, imageStyles), {}, {
          "data-testid": formatDataTestId(baseDataTestId, 'Image')
        }, cardInnerStyles), {}, {
          children: _jsx(Image, _objectSpread({
            src: formatAssetsUrl((_item$picture = item.picture) !== null && _item$picture !== void 0 ? _item$picture : ''),
            alt: item.title,
            borderTopRadius: "base"
          }, imageStyle))
        }))]
      }), item.title);
    })
  }));
}
var travelGuidesContainerStyles = {
  flexDirection: {
    mobile: 'column',
    sm: 'column',
    lg: 'row'
  },
  mb: '2xl',
  gap: 'lg',
  minH: {
    mobile: '292px',
    lg: '0'
  }
};
var cardStyles = {
  flexDirection: {
    mobile: 'column-reverse',
    sm: 'row'
  },
  borderWidth: '1px',
  borderRadius: 'lg',
  borderColor: 'var(--chakra-colors-lightGrey4)',
  padding: {
    mobile: 'md',
    lg: 'var(--chakra-space-md) var(--chakra-space-lg)'
  },
  gap: 'lg'
};
var titleStyles = {
  color: 'tertiary',
  fontSize: 'var(--chakra-fontSizes-3xxl)',
  fontFamily: 'var(--chakra-fonts-header)',
  fontWeight: 'var(--chakra-fontWeights-black)',
  lineHeight: {
    mobile: '2.75rem'
  },
  mb: {
    mobile: 0,
    lg: 'md'
  },
  mt: {
    mobile: '0'
  }
};
var buttonStyles = {
  padding: 'var(--chakra-space-sm) var(--chakra-space-md)',
  mb: 'md',
  w: 'full',
  h: 'auto',
  whiteSpace: 'normal',
  mt: {
    mobile: 'md',
    lg: '0'
  }
};
var descriptionStyles = {
  mb: {
    lg: '20px'
  }
};
var imageStyles = {
  minW: {
    mobile: '16rem',
    sm: '13.563rem'
  },
  height: {
    mobile: '13.75rem',
    sm: '15.375rem',
    md: '16.25rem'
  },
  bgColor: 'lightGrey4',
  borderRadius: 'base'
};
var imageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
var cardInnerStyles = {
  width: {
    mobile: 'full',
    lg: '50%'
  }
};